export default "__VITE_ASSET__DKwjE3pW__"